import { GET_ACCOUNT_REQUEST } from '../actions/auth';
import accountHelpers from '../../utils/accountHelpers';

const initialState = {
  account: accountHelpers.getUser() || {},
  isAuthorized: !!accountHelpers.getUser() && !!accountHelpers.getToken(),
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ACCOUNT_REQUEST.SUCCESS:
      accountHelpers.setUser(payload.data.data.response[0]);

      return {
        ...state,
        account: payload.data.data.response[0],
        isAuthorized: true,
      };

    default:
      return state;
  }
};

export default reducer;
